/* The portal cards are the single campaign source for both navigation menus. */
(() => {
  const selector = '.header__linklist-link, .mobile-nav__link';
  const isPortal = a => {
    const raw = a.getAttribute('href');
    if (!raw || raw.trim().startsWith('#')) return false;
    const u = new URL(a.href, location.href);
    return u.origin === location.origin && (u.searchParams.get('view') === 'promociones' || u.pathname === '/pages/promociones');
  };
  let campaignData = [];
  let labels = {};
  const menus = [];
  const close = item => { item.panel.hidden = true; item.button.setAttribute('aria-expanded', 'false'); };
  const active = c => c.enabled && (!c.start || Date.now() >= Date.parse(c.start)) && (!c.end || Date.now() < Date.parse(c.end));
  const refresh = () => menus.forEach(item => {
    const campaigns = campaignData.filter(active);
    const signature = JSON.stringify(campaigns);
    if (item.signature === signature) return;
    item.signature = signature;
    item.panel.querySelectorAll('[data-promo-nav-campaign]').forEach(li => li.remove());
    campaigns.forEach(c => {
      const li = document.createElement('li');
      li.dataset.promoNavCampaign = '';
      const a = document.createElement('a');
      a.href = c.url;
      a.textContent = c.title;
      a.className = 'ef-promo-nav__link';
      li.append(a); item.panel.append(li);
    });
  });
  const install = (link, i) => {
    if (link.closest('.ef-promo-nav')) return;
    const mobile = link.classList.contains('mobile-nav__link');
    const wrap = document.createElement('div');
    wrap.className = 'ef-promo-nav' + (mobile ? ' ef-promo-nav--mobile' : '');
    link.before(wrap); wrap.append(link);
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'ef-promo-nav__toggle';
    button.setAttribute('aria-label', labels.toggle || link.textContent.trim());
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', 'ef-promo-nav-' + i);
    const chevron = document.createElement('span'); chevron.textContent = '⌄'; chevron.setAttribute('aria-hidden', 'true'); button.append(chevron);
    const panel = document.createElement('ul');
    panel.id = 'ef-promo-nav-' + i; panel.className = 'ef-promo-nav__panel'; panel.hidden = true;
    const all = document.createElement('li'), allLink = document.createElement('a');
    allLink.href = link.href; allLink.textContent = labels.all || link.textContent.trim(); allLink.className = 'ef-promo-nav__link ef-promo-nav__all'; all.append(allLink); panel.append(all);
    wrap.append(button, panel);
    const item = {wrap, button, panel}; menus.push(item);
    const open = () => { refresh(); panel.hidden = false; button.setAttribute('aria-expanded', 'true'); };
    button.addEventListener('click', () => panel.hidden ? open() : close(item));
    if (!mobile) {
      wrap.addEventListener('mouseenter', open);
      wrap.addEventListener('mouseleave', () => { if (!wrap.contains(document.activeElement)) close(item); });
    }
    wrap.addEventListener('keydown', e => { if (e.key === 'Escape') { close(item); button.focus(); } });
    wrap.addEventListener('focusout', e => { if (!wrap.contains(e.relatedTarget)) close(item); });
    document.addEventListener('click', e => { if (!wrap.contains(e.target)) close(item); });
    panel.addEventListener('click', e => { if (e.target.closest('a')) close(item); });
  };
  const init = async () => {
    const links = [...document.querySelectorAll(selector)].filter(isPortal);
    if (!links.length) return;
    let hub = document.querySelector('[data-promotions-hub]');
    try {
      if (!hub) {
        const response = await fetch(links[0].href, {credentials:'same-origin'});
        if (!response.ok) return;
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        hub = parsed.querySelector('[data-promotions-hub]');
      }
      if (!hub) return;
      labels = {all:hub.dataset.menuAll, toggle:hub.dataset.menuToggle};
      campaignData = [...hub.querySelectorAll('[data-promotion-card]')].map(card => ({
        enabled:card.dataset.enabled === 'true', start:card.dataset.start, end:card.dataset.end,
        title:[card.querySelector('h2')?.textContent.trim(), card.querySelector('.ef-promotion__benefit')?.textContent.trim()].filter(Boolean).join(' · '),
        url:card.querySelector('.ef-promotion__cta')?.getAttribute('href')
      })).filter(c => c.url && c.title);
      links.forEach(install); refresh();
    } catch (_) { /* Keep the original portal links functional if loading fails. */ }
  };
  init();
  setInterval(refresh,15000);
  document.addEventListener('visibilitychange',refresh);
  document.addEventListener('shopify:section:load',init);
})();
